import consumer from "./consumer"

consumer.subscriptions.create({ channel: "PresenceChannel" });
